import { render, staticRenderFns } from "./uploader-group.vue?vue&type=template&id=f9156c72&scoped=true"
import script from "./uploader-group.vue?vue&type=script&lang=js"
export * from "./uploader-group.vue?vue&type=script&lang=js"
import style0 from "./uploader-group.vue?vue&type=style&index=0&id=f9156c72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9156c72",
  null
  
)

export default component.exports